// extracted by mini-css-extract-plugin
module.exports = {"bg":"map-module--bg--2-DXr","marker":"map-module--marker--3bbYy","lostDog":"map-module--lostDog--1qgMN"};